import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getUserDetails, doUserCreate, doUserUpdate 
} from "../../../../redux/user/userState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";

const UserForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();

  	useEffect(() => {
        getRecord(recordId ?? 0);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){			
			const { user_details, ...rest } = recordData;
	        const initialValues = {
	            ...rest,
				first_name: user_details?.udt_first_name,
				last_name: user_details?.udt_last_name,
	        };
	        
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {							
			formData.id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-1 md:grid-cols-4 gap-4">
					<div className="col-span-1 md:col-span-1 border-r pr-4">
						<FormItem className="font-medium mb-2"
							name="user_account_id"
							label="Account"
							rules={[requiredField()]}
						>
							{mode === 'edit' ?
							<Select id="user_account_id"
								className="input-field"
								showSearch
								allowClear={true}
								options={recordData?.accountOptions}
							/>
							: <label className="ps-3 dark:text-white">{recordData?.sdd_type_name}</label>
							}	                
						</FormItem>

						<FormItem className="font-medium mb-2"
							name="user_role_id"
							label="User Role"
							rules={[requiredField()]}
						>
							{mode === 'edit' ?
							<Select id="user_role_id"
								className="input-field"
								showSearch
								allowClear={true}
								options={recordData?.userRoleList}
								mode="multiple"
							/>
							: <label className="ps-3 dark:text-white">{recordData?.sdd_type_name}</label>
							}	                
						</FormItem>
					</div>
					<div className="col-span-1 md:col-span-3">
						<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
							<FormItem className="font-medium mb-2"
								name="first_name"
								label="First Name"
								rules={[requiredField()]}
							>
								{mode === 'edit' ?
								<Input id="first_name"
									className="input-field"
									placeholder="First Name"
									maxLength={100}
								/>
								: <label className="ps-3 dark:text-white">{recordData?.first_name}</label>
								}
							</FormItem>
							<FormItem className="font-medium mb-2"
								name="last_name"
								label="Last Name"
								rules={[requiredField()]}
							>
								{mode === 'edit' ?
								<Input id="last_name"
									className="input-field"
									placeholder="Last Name"
									maxLength={100}
								/>
								: <label className="ps-3 dark:text-white">{recordData?.last_name}</label>
								}
							</FormItem>

							<FormItem className="font-medium mb-2"
								name="email"
								label="Email"
								rules={[requiredField()]}
							>
								{mode === 'edit' ?
								<Input id="email"
									className="input-field"
									placeholder="Email"
									maxLength={100}
								/>
								: <label className="ps-3 dark:text-white">{recordData?.email}</label>
								}
							</FormItem>

							<FormItem className="font-medium mb-2"
								name="password"
								label="Password"
								rules={recordData?.id > 0 ? [] : [requiredField()]}
							>
								{mode === 'edit' ?
								<Input id="password"
									className="input-field"
									placeholder="Min. of 8 alpha numeric and special characters"
									type="password"
									maxLength={100}
								/>
								: <label className="ps-3 dark:text-white">**********</label>
								}
							</FormItem>

							<FormItem className="font-medium mb-2"
								name="password_confirmation"
								label="Confirm Password"
								rules={recordData?.id > 0 ? [] : [requiredField()]}
							>
								{mode === 'edit' ?
								<Input id="password_confirmation"
									className="input-field"
									placeholder="Confirm Password"
									type="password"
									maxLength={100}
								/>
								: <label className="ps-3 dark:text-white"></label>
								}
							</FormItem>
						</div>
						
					</div>
					
	 			</div>	 	
	 			<CrudButtons baseRoute="/console/users" mode={mode} recordId={recordId} />			 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.user.userDetails?.data,
  	requesting: state.user.userDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getUserDetails(id)),
  	doCreate: (data) => dispatch(doUserCreate(data)),
  	doUpdate: (data) => dispatch(doUserUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
